export default __webpack_public_path__ + "static/media/btnLogout.ce555b40.svg";